module.exports = __webpack_public_path__ + "img/classify_2.bbfe8b86.png";